import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StylesheetRoutingModule } from './stylesheet-routing.module';
import { StylesheetComponent } from './stylesheet.component';
import { FormsModule } from '@angular/forms';
import { ClipboardModule } from 'ngx-clipboard';
import { SharedModule } from '@app/shared';

import { BtnComponent } from '@app/pages/stylesheet/shared/btn/btn.component';
import { BadgeComponent } from '@app/pages/stylesheet/shared/badge/badge.component';
import { AlertMessageComponent } from '@app/pages/stylesheet/shared/alert-message/alert-message.component';
import { DropdownGeneratorComponent } from '@app/pages/stylesheet/shared/dropdown-generator/dropdown-generator.component';

@NgModule({
  declarations: [StylesheetComponent, BadgeComponent, BtnComponent, DropdownGeneratorComponent],
  imports: [StylesheetRoutingModule, CommonModule, FormsModule, ClipboardModule, SharedModule, AlertMessageComponent]
})
export class StylesheetModule {}
